import styles from "./Advice.module.css";
import Card from "../Card/Card";
import dice from "../../assets/icon-dice.svg";

import { useState, useEffect } from "react";

const Advice = () => {
  const [content, setContent] = useState({});
  const [clicked, setClicked] = useState(false);

  const clickHanlder = () => {
    setClicked((prev) => !prev);
    fetchAdvice();
  };

  const fetchAdvice = async () => {
    try {
      const response = await fetch("https://api.adviceslip.com/advice", {
        method: "GET",
      });
      const adviceData = await response.json();
      console.log(adviceData);
      setContent({ id: adviceData.slip.id, content: adviceData.slip.advice });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAdvice();
    return () => {};
  }, [clicked]);
  return (
    <Card className={styles.display}>
      <h2 className={styles.h2}>{`advice #${content.id}`}</h2>
      <p className={styles.p}>{`"${content.content}"`}</p>
      <span className={styles.divider}></span>
      <button className={styles.button} onClick={clickHanlder}>
        <img src={dice} alt="Generate new advice"></img>
      </button>
    </Card>
  );
};

export default Advice;
